import { api_GET, api_POST, api_PUT } from "./_api.js";

const usuario_api = {
  authenticate: (login = { login: "", password: "" }) => {
    const promise = new Promise((resolve, reject) => {
      api_POST(`Authenticate/`, login)
        .then(result => {
          resolve(result)
        })
        .catch(result => reject(result));
    });
    return promise;
  },
  esqueceuSenha: (email) => {
    const promise = new Promise((resolve, reject) => {
      api_POST(`Authenticate/RecuperarSenha`, email)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  trocaSenha: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST(`Authenticate/TrocarSenha`, json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getList: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Usuario`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  GetListAtivos: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Usuario/GetListAtivos`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  GetFuncionalidades: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Usuario/GetFuncionalidades`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getItem: (id) => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Usuario/GetItem/${id}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  post: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST("Usuario", json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  put: (usuario) => {
    const promise = new Promise((resolve, reject) => {
      api_PUT("Usuario", usuario)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  PostPermissoes: (id, funcionalidadeAcos) => {
    const promise = new Promise((resolve, reject) => {
      api_POST(`Usuario/PostPermissoes/${id}`, funcionalidadeAcos)
        .then(result => {
          resolve(result)
        })
        .catch(result => reject(result));
    });
    return promise;
  },
  PostUsuarioFiscalizacaoEtapa: (id, funcionalidadeAcos) => {
    const promise = new Promise((resolve, reject) => {
      api_POST(`Usuario/PostUsuarioFiscalizacaoEtapa/${id}`, funcionalidadeAcos)
        .then(result => {
          resolve(result)
        })
        .catch(result => reject(result));
    });
    return promise;
  },
}

export default usuario_api;
